import React from "react";
import { useFormContext } from "react-hook-form";
import { ActionButton } from "../../../../../Common/Buttons/ActionButton";
import { ParcelImportFieldConfig, ParcelImportWizardFormData } from "../types";
import ImportFieldSourceSelect from "./ImportFieldSourceSelect";
import ImportFieldSourceText from "./ImportFieldSourceText";

const ImportFieldSourceSwapper = ({
  disabled,
  fieldConfig,
  fieldPath,
}: {
  disabled: boolean;
  fieldConfig: ParcelImportFieldConfig;
  fieldPath: `mapping.${string}`;
}) => {
  const sourceFieldPath = `${fieldPath}.source` as const;
  const fieldTypeFieldPath = `${fieldPath}.fieldType` as const;

  const { getValues, setValue, unregister } =
    useFormContext<ParcelImportWizardFormData>();

  const fieldType = getValues(fieldTypeFieldPath);
  const usingHardcodedInput = fieldType === "HARDCODED";
  const swapperLabel = `Swap ${sourceFieldPath} Input`;

  const swapInputs = () => {
    unregister(sourceFieldPath);
    setValue(fieldTypeFieldPath, usingHardcodedInput ? "MAPPED" : "HARDCODED");
  };

  return (
    <>
      {usingHardcodedInput ?
        <ImportFieldSourceText
          disabled={disabled}
          fieldConfig={fieldConfig}
          fieldName={sourceFieldPath}
        />
      : <ImportFieldSourceSelect
          disabled={disabled}
          fieldConfig={fieldConfig}
          fieldName={sourceFieldPath}
        />
      }
      {!disabled && (
        <ActionButton
          icon="arrow-left-right"
          aria-label={swapperLabel}
          onPress={swapInputs}
        />
      )}
    </>
  );
};

export default ImportFieldSourceSwapper;
